import { FC } from "react";

import { LabelAtom } from "./atoms/LabelAtom";
import { CommonInputControlsProps, NumbericOnlyProps } from "./types";
import { VoidFunc } from "../../../helpers/functions/types";
import { NAMED_NARROW_INPUT_STYLES, NAMED_WRAPPER_STYLES } from "./constants";
import { NumbericAtom } from "./atoms/NumbericAtom";
import { PERCENTAGE_MESSAGE } from "../../constants";

type NamedNumbericProps = CommonInputControlsProps<
  number,
  VoidFunc<HTMLInputElement>
>;

export const NamedNumberic: FC<NamedNumbericProps & NumbericOnlyProps> = ({
  title,
  subtitle,
  customId,
  value,
  onChange,
  min,
  max,
  defaultValue,
  step,
  addSimilarity = false,
  addPercentage = false,
  styleVariant = "slideOver",
  className,
}) => {
  const inputId = customId ?? `${title}NumberValue`;

  return (
    <div
      className={
        className ??
        (styleVariant === "srLabel" || styleVariant === "detailPage"
          ? ""
          : "px-4")
      }
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`${NAMED_WRAPPER_STYLES} ${NAMED_NARROW_INPUT_STYLES[styleVariant]}`}
      >
        <LabelAtom
          title={`${title}${addSimilarity ? " Similarity" : ""}${
            addPercentage ? PERCENTAGE_MESSAGE : ""
          }`}
          subtitle={subtitle}
          htmlFor={inputId}
          srOnly={styleVariant === "srLabel" || styleVariant === "detailPage"}
          narrowInput={true}
        />
        <NumbericAtom
          name={inputId}
          value={value !== undefined ? value : defaultValue}
          onChange={onChange}
          min={min ?? 0} //there are no settings in panel for which negative numbers make sense
          max={max}
          step={step}
          srLabel={styleVariant === "srLabel" || styleVariant === "detailPage"}
        />
      </div>
    </div>
  );
};
